import {invisiblyApi} from "../api/invisibly-api";
import {InvisiblyApiResponse} from "../../services/api/api-response.types";
import SurveyService from "../../services/surveys/survey.service";
import { createShare } from "../../services/surveys/surveys.helpers";
import { removeLoadingNotification } from "../notification/notification.slice";
import { AiServiceTriggerResponseJSON, SurveySummaryData, SurveySummaryDataJSON } from "./survey.types";
import { AiServiceTrigger } from "../ai/ai.types";
import { APITagType } from "../api/invisibly-api.types";

const summaryEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    createSummary: builder.mutation<AiServiceTrigger, { ext_survey_id: string }>({
      query: ({ ext_survey_id }) => ({
        data: {ext_survey_id, service: "summary"},
        method: 'post',
        url: 'b2b/summary',
      }),
      transformResponse: (response: InvisiblyApiResponse<AiServiceTriggerResponseJSON>) => {
        return SurveyService.parseAiServiceTrigger(response.item);
      },
      async onQueryStarted({ ext_survey_id }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (!data) {
            return;
          }

        } catch (error) {
          console.error('Error creating summary', error);
        }
      },
    }),
    getSurveySummary: builder.query<SurveySummaryData, { ext_survey_id: string, share?: boolean }>({
      query: ({ ext_survey_id, share }) => ({
        method: 'get',
        params: share === true ? undefined : { use_ext_survey_id: true },
        url: createShare(`b2b/survey/${ext_survey_id}/summary`, share, 'b2b'),
        handleErrorGlobally: false,
      }),
      providesTags: [APITagType.Summaries],
      transformResponse: (response: InvisiblyApiResponse<SurveySummaryDataJSON>) => {
        return SurveyService.parseSurveySummary(response.item);
      },
      async onCacheEntryAdded(
        { ext_survey_id },
        { cacheDataLoaded, cacheEntryRemoved, updateCachedData }
      ) {
        try {
          await cacheDataLoaded;
          removeLoadingNotification({
            id: "media_plan_notification_id",
            summary: "media_plan_notificaiton",
            theme: "info",
          });
        } catch (error) {
          console.error('Error fetching media plan', error);
        }
        // Cleanup when the cache subscription is no longer active
        await cacheEntryRemoved;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useCreateSummaryMutation, useGetSurveySummaryQuery,
} = summaryEndpoints;
